'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PauseCircled = require('./PauseCircled');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PauseCircled).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/PauseCircled/index.js
// module id = 1248
// module chunks = 1